/*    
<summary>
   This file is used to provide initial values or state to the config Data observables.
   Developer:Ashish Singh, Created Date: 04-July-2025
</summary>
*/

import { IAddFotaHostConfig } from "../../models/response/IFotaNewResponse";


export const addEditFotaHostConfigInitialState: IAddFotaHostConfig = {
  ConfigName: "",
  Version: "",
  File: "",
  FileContent: "",
  FileType:0,
  Description: "",
  FileName: "",
  IsCustomFileNameWithExtension: false,
  IsCustomFileNameWithoutExtension: false,
  WantToUpdateFile:"false",
};
